import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import NewSelectMultiple from 'common/components/fields/NewSelectMultiple';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { FORM_RULES } from 'helpers/validations';
import Button from '@material-ui/core/Button';
import { Field, reduxForm, getFormValues, Form } from 'redux-form';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { connect } from 'react-redux';
import { Grid, Typography, Paper } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import CopyPasteIcon from '@material-ui/icons/FilterNone';
import CloseIcon from '@material-ui/icons/Close';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import { isMobile } from 'react-device-detect';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import { createCouponCode, editCouponCode, getCouponCodeById } from './couponCodesActions';
import { getStationActiveActions } from '../activeActions/activeActionsScripts';

function CouponCodesForm(props) {
  const [couponCodes, setCouponCodes] = useState([]);
  const { couponcode_id } = props.router.params;
  const { id } = props.auth.user.establishments[0].stations[0];
  const { detail, buttonLoading } = props.couponCodes;
  const { getCouponCodeById } = props;
  const isEditMode = Boolean(couponcode_id);
  const isButtonLoading = Boolean(buttonLoading);
  const onlyNumbers = (values) => values && values.replace(/[^\d]/g, '');
  const containerStyles = {
    margin: isMobile ? '0 auto' : '24px auto',
    padding: isMobile ? 16 : 32,
    maxWidth: 1080,
  };
  const columnBorderStyle = isMobile ? {} : { borderRight: '1px solid #C4C4C4' };
  const codeColumnJustify = isMobile ? 'flex-start' : 'center';

  const opcoesActions = props.activeActions.list.map((action) => ({
    id: action.id,
    title: action.name,
  }));

  useEffect(() => {
    if (_.isEmpty(props.activeActions.list)) {
      props.getStationActiveActions(id);
    }
  }, [props.activeActions.list, id, props.getStationActiveActions]);

  useEffect(() => {
    if (!isEditMode) {
      setCouponCodes([]);
      return;
    }

    setCouponCodes([]);
    getCouponCodeById(couponcode_id);
  }, [couponcode_id, getCouponCodeById, isEditMode]);

  useEffect(() => {
    if (!isEditMode) {
      return;
    }

    const normalizedCouponId = Number(couponcode_id);

    if (!detail || detail.id !== normalizedCouponId) {
      return;
    }

    const formattedCodes =
      detail?.coupon_codes?.map((code) => ({ id: code.id, code: code.code })) || [];

    setCouponCodes(formattedCodes);
  }, [detail, couponcode_id, isEditMode]);

  const handleAddCouponCode = () => {
    const code = props.formValues?.code;
    const codeCleaned = code?.toUpperCase()?.trim();

    if (
      !_.isEmpty(codeCleaned) &&
      _.isEmpty(couponCodes.filter((item) => item.code === codeCleaned))
    ) {
      setCouponCodes([...couponCodes, { id: `_${couponCodes.length + 1}`, code: codeCleaned }]);
    }

    props.change('code', null);
  };

  const handleCloseCouponCode = (code) => {
    setCouponCodes(couponCodes.filter((item) => item.id !== code.id));
  };

  const handleClipboardClick = (code) => {
    navigator.clipboard.writeText(code);
    toastr.success('Copiado!', `Código ${code} copiado com sucesso!`);
  };

  function onSubmit(values) {
    const coupon_codes = couponCodes.map((item) => item.code);

    if (isEditMode) {
      props.editCouponCode({ ...values, coupon_codes }, couponcode_id, props.router);
      return;
    }

    props.createCouponCode({ ...values, coupon_codes }, id, props.router);
  }

  return (
    <Form role="form" onSubmit={props.handleSubmit(onSubmit)} noValidate>
      <Paper style={containerStyles} elevation={0}>
        <Grid container spacing={4} justify="center">
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
              {isEditMode ? 'Salvar cupom' : 'Cadastrar cupom'}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} style={columnBorderStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label="Título do cupom"
                  name="title"
                  validate={[FORM_RULES.required]}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  type="textarea"
                  multiline
                  rowsMax={6}
                  label={'Descrição'}
                  name="description"
                  rows={4}
                  placeholder="Breve descrição sobre o cupom"
                  cols="12 12 12 6"
                  required
                />
              </Grid>

              <Grid item xs={6}>
                <Field
                  component={InputLabelOutlined}
                  label="Valor do desconto"
                  normalize={onlyNumbers}
                  name="percentage"
                  validate={[FORM_RULES.required, FORM_RULES.percentage]}
                  required
                />
              </Grid>

              <Grid item xs={6}>
                <Field
                  component={InputLabelOutlined}
                  label="Quantia disponível"
                  name="amount"
                  normalize={onlyNumbers}
                  validate={[FORM_RULES.required]}
                  required
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4} style={columnBorderStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} style={{ marginTop: -16 }}>
                <Field
                  component={NewSelectMultiple}
                  label={'Pesquisar'}
                  options={opcoesActions}
                  name="actions"
                  margin="normal"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
            <Grid container spacing={2} justify={codeColumnJustify} alignItems="center">
              <Grid item xs={12} md={7}>
                <Field component={InputLabelOutlined} label="Cadastre o código aqui" name="code" />
              </Grid>
              <Grid item xs={12} md={5}>
                <Button onClick={handleAddCouponCode} color="primary" fullWidth={isMobile}>
                  criar código
                </Button>
              </Grid>
              <Grid item xs={12}>
                <List dense component="nav">
                  {couponCodes.map((coupon) => (
                    <React.Fragment key={coupon.id}>
                      <ListItem
                        button
                        style={{ padding: 12 }}
                        onClick={() => handleClipboardClick(coupon.code)}>
                        <ListItemIcon>
                          <CopyPasteIcon style={{ color: '#5759FB' }} />
                        </ListItemIcon>
                        <ListItemText primary={coupon.code} style={{ color: '#043565' }} />
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            onClick={() => handleCloseCouponCode(coupon)}
                            aria-label="delete">
                            <CloseIcon style={{ color: '#C4C4C4' }} />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          style={{ marginTop: isMobile ? 24 : 32 }}>
          <Grid item>
            <SecondaryButton onClick={() => props.router.push('/owner/coupons')} color="primary">
              Cancelar
            </SecondaryButton>
          </Grid>
          <Grid item>
            <PrimaryButton type="submit" color="primary" disabled={isButtonLoading}>
              {isEditMode ? 'Salvar cupom' : 'Cadastrar cupom'}
            </PrimaryButton>
          </Grid>
        </Grid>
      </Paper>
    </Form>
  );
}

CouponCodesForm.propTypes = {
  activeActions: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
      })
    ),
  }),
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.arrayOf(
        PropTypes.shape({
          stations: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
          ),
        })
      ),
    }),
  }),
  change: PropTypes.func,
  couponCodes: PropTypes.shape({
    detail: PropTypes.shape({
      id: PropTypes.number,
      coupon_codes: PropTypes.array,
    }),
    buttonLoading: PropTypes.bool,
  }),
  createCouponCode: PropTypes.func,
  editCouponCode: PropTypes.func,
  formValues: PropTypes.object,
  getCouponCodeById: PropTypes.func,
  getStationActiveActions: PropTypes.func,
  handleSubmit: PropTypes.func,
  router: PropTypes.shape({
    params: PropTypes.shape({
      couponcode_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    push: PropTypes.func,
  }),
};

const mapStateToProps = (state) => {
  const formValues = getFormValues('couponsForm')(state);

  return {
    auth: state.auth,
    couponCodes: state.couponCodes,
    activeActions: state.activeActions,
    formValues,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createCouponCode,
      editCouponCode,
      getCouponCodeById,
      getStationActiveActions,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'couponsForm',
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  })(CouponCodesForm)
);
